// extracted by mini-css-extract-plugin
export default {"errorMessage":"errorMessage_errorMessage__8vUht"};